import { Injectable, inject } from '@angular/core';
import { classes } from 'polytype';

import type { PromptAdapter } from '@app/modules/assets/models/prompt.model';
import { PROMPT_PATH } from '@app/shared/constants/api-route.config';
import { WithArtifactService } from '@app/shared/services/mixins/artifact.service';
import { WithAuditService } from '@app/shared/services/mixins/audit.service';
import { WithExportableService } from '@app/shared/services/mixins/export.service';
import { WithJobService } from '@app/shared/services/mixins/job.service';
import { WithLineageService } from '@app/shared/services/mixins/lineage.service';
import { WithLogService } from '@app/shared/services/mixins/log.service';
import { WithCrudVersionService } from '@app/shared/services/mixins/version.service';
import { WithWorkflowableService } from '@app/shared/services/mixins/workflow.service';
import { RestService } from '@app/shared/services/rest.service';
import { ToastNotificationService } from '@app/shared/services/toast-notification.service';

@Injectable({
    providedIn: 'root',
})
export class PromptService extends classes(
    WithCrudVersionService<PromptAdapter>,
    WithJobService,
    WithAuditService,
    WithArtifactService,
    WithWorkflowableService,
    WithLogService,
    WithExportableService,
    WithLineageService,
) {
    protected endpoint = PROMPT_PATH;

    protected readonly api = inject(RestService);
    protected readonly toast = inject(ToastNotificationService);
}
